module.exports = __webpack_public_path__ + "img/prizesTab2.4b57b556.png";